import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ZonesDTO, ZonesFilters } from '../../models/zone';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';

@Injectable({
    providedIn: 'root',
})
export class LaravelZonesService {
    constructor(private httpClient: HttpClient) {}

    private get ROUTES() {
        return {
          list: environment.baseUrl + '/api/zones',
          show: environment.baseUrl + '/api/zones',
          store: environment.baseUrl + '/api/zones',
          destroy: environment.baseUrl + '/api/zones',
        };
    }

    public list(
        page: number,
        per_page: number,
        order: string,
        direction: string,
        filters: ZonesFilters,
        includes?: string[]
      ): Observable<ListResultDTO<ZonesDTO>> {
        let params = {};
        if (order) params['order'] = '' + order;
        if (direction) params['direction'] = '' + direction;
        if (includes) params['includes[]'] = includes;
        if (filters) {
          if (filters.search) params['search'] = filters.search;
          if (filters.tenant_id) params['tenant_id'] = filters.tenant_id;
        }

        if (per_page) {
          params['per_page'] = '' + per_page;
          if (page) params['page'] = '' + page;
          return this.httpClient.get<ListResultDTO<ZonesDTO>>(
            this.ROUTES.list,
            {
              params: new HttpParams({ fromObject: params }),
            }
          );
        } else {
          return this.httpClient
            .get<ZonesDTO[]>(this.ROUTES.list, {
              params: new HttpParams({ fromObject: params }),
            })
            .pipe(
              map((results) => {
                return {
                  data: results,
                  total: results.length,
                };
              })
            );
        }
    }

    public show(id: number): Observable<ZonesDTO> {
        let params = { id: '' + id };
        return this.httpClient.get<ZonesDTO>(this.ROUTES.show, {
          params: new HttpParams({
            fromObject: params,
          }),
        });
    }

    public upsert(zone: ZonesDTO): Observable<ZonesDTO> {
        if (zone.id) {
          return this.httpClient.put<ZonesDTO>(`${this.ROUTES.store}/${zone.id}`, {
            ...zone,
          });
        } else {
          return this.httpClient.post<ZonesDTO>(`${this.ROUTES.store}`, {
            ...zone,
          });
        }
    }

    public delete(id: number) {
    let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
    }
}
